import { CameraType } from "APP_ROOT/data/media";
export default {
  name: "stop_sign_violation",
  localization: {
    en: {
      title: "Rolling Stop Detected",
      settingsHeader: "Rolling Stop Detection",
    },
    fr: {
      title: "Arrêt roulant détecté",
      settingsHeader: "Détection d'arrêt roulant",
    }
  },
  proto: {
    name: "EVENT_RAVEN_STOP_SIGN_VIOLATION",
    value: 177
  },
  isBuiltByDefault: true,
  isBuiltEnvironmentOverride: {
    showcase: false,
    prod: false
  },
  visibility:{
    reports: true,
    coaching: true,
    coachingNoFacialRecognition: true,
    warning: true,
  },
  isConsumerFeature: false,
  defaultCameraType: CameraType.CAMERA_ROAD,
  showBetaDecoration: false,
}
